import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EndpointOptions, EndpointService } from '../endpoint.service';
import { BaseDao } from '../dao.module';
import { Order } from '../model/order';

@Injectable()
export class OrdersDaoService extends BaseDao<any> {

  constructor(endpoint: EndpointService) {
    super(endpoint);
    this.configure('/orders/', true);
  }

  get(key: string, entity?: string): Observable<any> {
    entity = this.getEntity(entity);
    const url = this.getUrl(entity, key);

    return this.handle(this.endpoint.getOne(url, this.getOptions()));
  }

  getList(key: string, entity?: string): Observable<any[]> {
    entity = this.getEntity(entity);
    const url = this.getUrl(entity, key);

    return this.handle(this.endpoint.getMany(url, this.getOptions()));
  }

  getFilteredListById(params: any): Observable<any[]> {
    const url = '/s/orders?filter=' + params.filter + '&id=' + params.key;
    return this.handle(this.endpoint.getMany(url, this.getOptions()));
  }

  put(key: string, data: any, status?: string): Observable<any> {
    const url = '/s/orders/' + key + '?action=' + status;

    return this.handle(this.endpoint.put(url, data, this.options()));
  }

  protected getOptions(): EndpointOptions {
    return {
      secure: true,
      mapper: order => Order.fromRaw(order),
      resource: false,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/dao-service/orders-dao.service.ts